import { Trans } from "react-i18next";
import { cn } from "../../../../../utils/classnames";

/**
 * Renders a translation that carries its own light markup:
 *   <p>…</p>          one paragraph (the design puts a small gap between them)
 *   <strong>…</strong> a phrase the design sets in bold
 *
 * A plain string with no tags renders as-is, so every copy block can go
 * through here.
 *
 * The paragraphs take their size, line height and colour from the wrapper's
 * `className`. The trailing `!` on those rules is needed because the global
 * un-layered `p { margin-bottom; font-size; … }` styles would otherwise win
 * over Tailwind.
 *
 * @param paragraphGapClass - the space between paragraphs, e.g. "tw:[&_p+p]:mt-[5px]!"
 * @param strongClassName - extra classes for the bold phrases (e.g. a colour)
 */
export const RichText = ({
  i18nKey,
  className,
  paragraphGapClass = "tw:[&_p+p]:mt-[5px]!",
  strongClassName,
}) => (
  <div
    className={cn(
      "tw:[&_p]:mb-0! tw:[&_p]:[font-size:inherit]! tw:[&_p]:[line-height:inherit]! tw:[&_p]:[color:inherit]! tw:[&_p]:[font-family:inherit]!",
      paragraphGapClass,
      className
    )}
  >
    <Trans
      i18nKey={i18nKey}
      components={{
        p: <p />,
        strong: <strong className={cn("tw:font-bold", strongClassName)} />,
      }}
    />
  </div>
);
